<template>
  <Configurator :config="config" :shopConfig="shopConfig" />
</template>

<script>
import Configurator from "../../components/Configurator/Configurator.vue";

export default {
  name: "app",
  components: {
    Configurator
  },
  data() {
    return {
      config: JSON.parse(this.$options._parentVnode.data.props.config),
      shopConfig: JSON.parse(this.$options._parentVnode.data.props.shopConfig)
    };
  }
};
</script>
